import { render, staticRenderFns } from "./yjfytzd.vue?vue&type=template&id=4d7a3072&scoped=true&"
import script from "./yjfytzd.vue?vue&type=script&lang=js&"
export * from "./yjfytzd.vue?vue&type=script&lang=js&"
import style0 from "./yjfytzd.vue?vue&type=style&index=0&id=4d7a3072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7a3072",
  null
  
)

export default component.exports